import * as React from "react";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import DropDown from "../../../hiberUiKit/src/molecules/DropDown/DropDown";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {none, option, Option} from "ts-option";
import Job from "../../../model/job/Job";
import {Dispatch} from "redux";
import {editJob} from "../../../store/action/job/job";
import Toast from "../../helper/Toast";
import {connect} from "react-redux";
import {RootState} from "../../../store/reducer/root/RootState";
import JobWarrantyRegistrationStatus from "../../../model/job/JobWarrantyRegistrationStatus";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";

interface ReduxProps {
	jobWarrantyRegistrationStatuses: JobWarrantyRegistrationStatus[],
}

interface ComponentProps {
	job: Option<Job>
}

interface DispatchProps {
	editJob: (job: Job) => void
}

type Props = ComponentProps & DispatchProps & ReduxProps

class JobWarrantyRegistrationStatusDropDown extends React.PureComponent<Props> {

	render() {
		return (
			<InfoModule icon={Icon.Job} title={"Warranty Registration Status"}>
				<DropDown items={this.props.jobWarrantyRegistrationStatuses}
						  clearable
						  onClearClick={this.onResetValue}
						  itemToId={(item: JobWarrantyRegistrationStatus) => item.value}
						  itemToLabel={(item: JobWarrantyRegistrationStatus) => item.label}
						  selectedItemId={this.getSelectedItem()}
						  onSelect={this.onSelect}/>
			</InfoModule>
		)
	}

	getSelectedItem() {
		return this.props.job.flatMap(j => j.data.warrantyRegistrationStatus).orNull;
	}

	onResetValue = () => {
		this.updateJob(none);
	}

	onSelect = (warrantyRegistrationStatus: JobWarrantyRegistrationStatus) => {
		this.updateJob(option(warrantyRegistrationStatus.value));
	}

	updateJob = (warrantyRegistrationStatus: Option<string>) => {
		this.props.job.map(j => this.props.editJob(
			j.copy({data: j.data.copy({warrantyRegistrationStatus})})));
	}
}

function mapStateToProps(state: RootState) {
	const jobWarrantyRegistrationStatuses = state.jobStatus.jobWarrantyRegistrationStatuses.getOrElse([]);
	return {
		jobWarrantyRegistrationStatuses,
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		editJob: (job: Job) => dispatch(
			editJob(
				job,
				() => Toast.success("Register Warranty And Gas Safe updated", "Job details update"),
				(e) => notifyBugsnagAndShowToast(e, "Job details update"))
		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(JobWarrantyRegistrationStatusDropDown)
